export default __webpack_public_path__ + "static/media/ICON11.886b700a.svg";